export default __webpack_public_path__ + "static/media/obj7.396af97b.jpg";